import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { SuggestBox } from '../SuggestBox';

const styles = theme => createStyles({
  root: {
    maxWidth: '100%',
    width: 'fit-content'
  },
  disabled: {
    '& .suggest-box__indicators': {
      display: 'none'
    }
  }
});

const formatOptions = agencyList => agencyList.map(({
  hospiceBin,
  hospiceName
}) => ({
  value: hospiceBin,
  label: hospiceName
})).filter(({
  value
}) => value !== null);

const formatState = (currentAgency, agencyList) => ({
  hospiceBin: currentAgency.hospiceBin,
  hospiceName: currentAgency.hospiceName,
  formattedAgencyList: formatOptions(agencyList && agencyList.length ? agencyList : [currentAgency])
});

const defaultAgency = {
  hospiceBin: null,
  hospiceName: null
};
export const handleComponentDidUpdate = (prevHospiceBin, currentHospiceBin) => prevHospiceBin !== currentHospiceBin;
export class BareAgencyPicker extends React.PureComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleChange", ({
      label,
      value
    }) => {
      this.setState({
        hospiceBin: value,
        hospiceName: label
      });
      this.props.onAgencyChange(value);
    });

    _defineProperty(this, "componentDidUpdate", prevProps => {
      const {
        hospiceBin,
        hospiceName
      } = this.props.currentAgency;

      if (this.props.handleComponentDidUpdate(prevProps.currentAgency.hospiceBin, hospiceBin)) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          hospiceBin,
          hospiceName
        });
      }
    });

    this.state = formatState(this.props.currentAgency, this.props.agencyList);
  }

  static getDerivedStateFromProps(newProps, prevState) {
    if (newProps.currentAgency === defaultAgency && Array.isArray(newProps.agencyList) && newProps.agencyList.length && !newProps.agencyList.filter(({
      hospiceBin
    }) => hospiceBin === prevState.hospiceBin).length) {
      return {
        hospiceBin: newProps.agencyList[0].hospiceBin,
        hospiceName: newProps.agencyList[0].hospiceName,
        formattedAgencyList: formatOptions(newProps.agencyList)
      };
    } else if (newProps.currentAgency !== defaultAgency && !prevState.formattedAgencyList.find(({
      value
    }) => value === newProps.currentAgency.hospiceBin)) {
      return formatState(newProps.currentAgency, newProps.agencyList);
    }

    return null;
  }

  render() {
    const {
      hospiceBin,
      hospiceName,
      formattedAgencyList
    } = this.state;
    const {
      className,
      classes,
      disabled,
      selectProps
    } = this.props;

    if (disabled && !hospiceBin && !hospiceName) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: `${classes.root}${className ? ` ${className}` : ''}${disabled ? ` ${classes.disabled}` : ''}`
    }, /*#__PURE__*/React.createElement(SuggestBox, _extends({
      fitContent: true,
      disabled: disabled,
      placeholder: hospiceName,
      options: formattedAgencyList,
      creatable: // If no list available (including single current entry), allow custom
      !disabled && (!formattedAgencyList.length || formattedAgencyList.length < 2),
      value: {
        value: hospiceBin,
        label: hospiceName
      },
      onChange: this.handleChange
    }, selectProps)));
  }

}

_defineProperty(BareAgencyPicker, "displayName", 'AgencyPicker');

_defineProperty(BareAgencyPicker, "defaultProps", {
  currentAgency: defaultAgency,
  handleComponentDidUpdate,
  onAgencyChange: () => null
});

const AgencyPicker = withStyles(styles)(BareAgencyPicker);
AgencyPicker.displayName = 'AgencyPicker';
export default AgencyPicker;